import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;

  .ant-card-bordered {
    border: 1px solid #e7e5e4;
  }
  .ant-card {
    border-radius: 10px;
    /* padding: 24px; */
    box-shadow: 0px 0px 16px 0px #0000000a;
  }
  .ant-card-body {
    padding: 0px;
  }
`;
